export var DEFAULT_WRAPPER_ID = "jds-modal-portal-wrapper";
export var createWrapperAndAppendToBody = function createWrapperAndAppendToBody(elementId) {
  var element = document.createElement("div");
  element.setAttribute("id", elementId);
  document.body.appendChild(element);
  return element;
};